<template>
    <div id="roles">
        <ErrorMessages :errors="errors" :description="$t('ui.general.error')" :is_closable="true"></ErrorMessages>

        <table class="ui celled table">
            <thead class="center aligned">
                <tr>
                    <th>{{ $t('models.attributes.roles.name') }}</th>
                    <th>
                    </th>
                </tr>
            </thead>
            <tbody v-if="is_loading" class="center aligned">
                <tr class="loading">
                    <td colspan="2">
                        <div class="ui active centered inline loader"></div>
                    </td>
                </tr>
            </tbody>
            <tbody v-else class="center aligned">
                <Role v-for="role in roles" :key="role.identity" :role="role"></Role>
                <tr v-if="roles.length <= 0" class="center aligned">
                    <td colspan="2" >
                        <h5>{{ $t('ui.general.no_data') }}</h5>
                    </td>
                </tr>
            </tbody>
        </table>

        <div
            is="Paginator"
            :total_pages="total_pages"
            :current_page="current_page"
            change_page_channel="index_page"
            :disabled="is_loading"
            >
        </div>
    </div>
</template>

<script>
import Role from "./index/role.vue"
import Paginator from '@toolbox/pagination/paginator.vue'
import ErrorMessages from '@toolbox/error_box/main.vue'
export default {
    name: "RolesIndex",
    data: function () {
        return {
            is_initialized: false,
            is_loading: false,
            roles: [],
            errors: [],
        }
    },
    computed: {
        current_page: function() {
            return this.$store.state.provider.roles_module.pagination.current_page;
        },
        total_pages: function() {
            return this.$store.state.provider.roles_module.pagination.total_pages;
        },
    },
    created: function() {
    },
    mounted: function() {
        this.init();
    },
    watch: {
    },
    methods: {
        init: async function() {
            var that = this;
            try {
                await new Promise(resolve => {
                    that.is_initialized = false;
                    resolve();
                });
                await that.fetch_roles();
                await new Promise(resolve => {
                    that.is_initialized = true;
                    resolve();
                });
            } catch (e) {
                switch (e) {
                    default:
                    that.$noty.error("非預期的錯誤: " + e);
                    console.log("非預期的錯誤: ");
                    console.log(e);
                }
            } finally {
                // pagination channel
                that.$bus.$off('index_page');
                that.$bus.$on('index_page', function(page) {
                    that.fetch_roles(page);
                }.bind(this));
            }
        },
        fetch_roles: function(page = 1) {
            var that = this;
            if (that.is_loading == false) {
                that.errors = [];
                that.is_loading = true;
                var url = new RestUrl(that.$store.state.provider.routes.api_v1_provider_roles).parse(
                    {},
                    "?page="+page
                );
                return axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                    .then(function (response) {
                        if (response.data.status == "success") {
                            that.roles = response.data.roles;
                            that.$store.commit('provider/roles_module/set_current_page', response.data.pagination.current_page);
                            that.$store.commit('provider/roles_module/set_total_pages', response.data.pagination.total_pages);
                        } else {
                            console.log(response.data);
                            that.errors = response.data.errors;
                            // that.$noty.error('取得 職位 失敗: ' + message);
                            that.$noty.error(
                                that.$t('ui.notifications.error.fetch__name', {
                                    name: that.$t('models.roles'),
                                    reason: ': ' + response.data.errors
                                })
                            );
                        }
                    })
                    .catch(function (error) {
                        console.log(error.reponse);
                        that.$noty.error(
                            that.$t('ui.notifications.error.fetch__name', {
                                name: that.$t('models.roles'),
                                reason: ': ' + error
                            })
                        );
                    })
                    .then(function () {
                        setTimeout(function () {
                            that.is_loading = false;
                        }, 300);
                    });
            }
        },
    },
    components: {
        Role,
        Paginator,
        ErrorMessages,
    }
}
</script>

<style scoped>
#roles {
    overflow-x: auto;
}
</style>
